/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

interface BookingCardTitleProps {
    title: string;
    className?: string;
}

const BookingCardTitle = (props: BookingCardTitleProps) => {
    const {t} = useTranslation();
    return <h2 className={clsx("BookingCardTitle font-medium text-base  text-gray-900 text-center sm:text-left", props.className)}>{t(props.title)}</h2>;
};

export default BookingCardTitle;
